import { render, staticRenderFns } from "./InstructionsServiceLayout.vue?vue&type=template&id=6fbc3774"
import script from "./InstructionsServiceLayout.vue?vue&type=script&lang=js"
export * from "./InstructionsServiceLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports